export const IsOnGoing = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="7" height="6" viewBox="0 0 7 6" fill="none">
            <circle cx="3.62695" cy="3" r="3" fill="#F8FD00" />
        </svg>
    );
};

